import { render, staticRenderFns } from "./PlatformProfilePanel.vue?vue&type=template&id=0e4dc6ab&scoped=true"
import script from "./PlatformProfilePanel.vue?vue&type=script&lang=js"
export * from "./PlatformProfilePanel.vue?vue&type=script&lang=js"
import style0 from "./PlatformProfilePanel.vue?vue&type=style&index=0&id=0e4dc6ab&prod&lang=scss&scoped=true"
import style1 from "./PlatformProfilePanel.vue?vue&type=style&index=1&id=0e4dc6ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4dc6ab",
  null
  
)

export default component.exports